import styled from 'styled-components';

export const Container = styled.div`
  &.ql-editor {
    padding: 0;
    overflow: visible;
    white-space: normal;
    text-align: inherit;

    ol,
    ul {
      padding-left: 1.5em;
      margin: 0.4em 0;
      text-align: left;
    }

    li {
      padding-left: 0;
      margin-bottom: 0.1em;
    }

    p {
      margin: 0.4em 0;
    }
  }
`;
